import { Component, ElementRef, ViewChild, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { CouponService } from '../../_services/coupon.service';
import { Coupon } from '../../_models/Coupon';

@Component({
  selector: 'app-coupon-select',
  templateUrl: './coupon-select.component.html',
  styleUrls: ['./coupon-select.component.css']
})
export class CouponSelectComponent implements OnInit {

  public coupons: Coupon[];

  @Input()
  public couponSelectLabel: string;

  public selectedCouponIdValue = 0;

  @Input()
  get selectedCouponId() {
    return this.selectedCouponIdValue;
  }

  @ViewChild('couponSelect')
  couponSelect: ElementRef;

  @Output()
  public selectedCouponIdChange: EventEmitter<number> = new EventEmitter<number>();

  set selectedCouponId(value) {
    this.selectedCouponIdValue = value;

    if (Number.isNaN(value) || Number(value) < 1) {
      this.selectedCouponIdChange.emit(null);
    }

    this.selectedCouponIdChange.emit(this.selectedCouponIdValue);
  }

  constructor(
    private couponService: CouponService) {
  }

  ngOnInit() {
    this.couponService.listCoupons().subscribe(
        data => {
          this.coupons = data;
          if (!this.selectedCouponId) {
            this.selectedCouponIdValue = 0;
          }
        }
      );
  }
}
